// extracted by mini-css-extract-plugin
export default {"container":"styles__container--xXRjN","main-header":"styles__main-header--WLGgO"};